import { render, staticRenderFns } from "./PainelValorComponent.vue?vue&type=template&id=57b73806&"
import script from "./PainelValorComponent.vue?vue&type=script&lang=js&"
export * from "./PainelValorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports